// Операции над сценой.
//
// Набор намеренно маленький и ЗАКРЫТЫЙ: у каждой операции обязана
// быть обратная, иначе undo не работает (docs/02). Тест полноты
// в задаче 2.3 сверяет реестр с этим файлом и роняет сборку, если
// операция появилась без обратной.
//
// Поля prev заполняет СЕРВЕР при применении. Клиент их не знает
// и не может подделать: иначе кто угодно подсунул бы undo, который
// восстанавливает не то, что было.
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import { file_owm_v1_scene } from "./scene_pb.js";
/**
 * Describes the file owm/v1/ops.proto.
 */
export const file_owm_v1_ops = /*@__PURE__*/ fileDesc("ChBvd20vdjEvb3BzLnByb3RvEgZvd20udjEiKAoITGF5ZXJBZGQSHAoFbGF5ZXIYASABKAsyDS5vd20udjEuTGF5ZXIiSgoLTGF5ZXJSZW1vdmUSEAoIbGF5ZXJfaWQYASABKAkSIAoEcHJldhgCIAEoCzINLm93bS52MS5MYXllckgAiAEBQgcKBV9wcmV2IskBCgpMYXllclBhdGNoEhEKBG5hbWUYASABKAlIAIgBARIpCgl0cmFuc2Zvcm0YAiABKAsyES5vd20udjEuVHJhbnNmb3JtSAGIAQESEwoGaGlkZGVuGAMgASgISAKIAQESEwoGbG9ja2VkGAQgASgISAOIAQESJgoFcHJvcHMYBSABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0QgcKBV9uYW1lQgwKCl90cmFuc2Zvcm1CCQoHX2hpZGRlbkIJCgdfbG9ja2VkInIKC0xheWVyVXBkYXRlEhAKCGxheWVyX2lkGAEgASgJEiEKBXBhdGNoGAIgASgLMhIub3dtLnYxLkxheWVyUGF0Y2gSJQoEcHJldhgDIAEoCzISLm93bS52MS5MYXllclBhdGNoSACIAQFCBwoFX3ByZXYiSwoMTGF5ZXJSZW9yZGVyEhAKCGxheWVyX2lkGAEgASgJEgkKAXoYAiABKAUSEwoGcHJldl96GAMgASgFSACIAQFCCQoHX3ByZXZfeiKoAQoKU2NlbmVQYXRjaBIRCgRuYW1lGAEgASgJSACIAQESFQoIY2FudmFzX3cYAiABKAVIAYgBARIVCghjYW52YXNfaBgDIAEoBUgCiAEBEigKCXdvcmtfYXJlYRgEIAEoCzIQLm93bS52MS5Xb3JrQXJlYUgDiAEBQgcKBV9uYW1lQgsKCV9jYW52YXNfd0ILCglfY2FudmFzX2hCDAoKX3dvcmtfYXJlYSJgCgtTY2VuZVVwZGF0ZRIhCgVwYXRjaBgBIAEoCzISLm93bS52MS5TY2VuZVBhdGNoEiUKBHByZXYYAiABKAsyEi5vd20udjEuU2NlbmVQYXRjaEgAiAEBQgcKBV9wcmV2IlUKClNjZW5lQXBwbHkSHAoFc2NlbmUYASABKAsyDS5vd20udjEuU2NlbmUSIAoEcHJldhgCIAEoCzINLm93bS52MS5TY2VuZUgAiAEBQgcKBV9wcmV2IqMCCgJPcBINCgVvcF9pZBgBIAEoCRIlCglsYXllcl9hZGQYCiABKAsyEC5vd20udjEuTGF5ZXJBZGRIABIrCgxsYXllcl9yZW1vdmUYCyABKAsyEy5vd20udjEuTGF5ZXJSZW1vdmVIABIrCgxsYXllcl91cGRhdGUYDCABKAsyEy5vd20udjEuTGF5ZXJVcGRhdGVIABItCg1sYXllcl9yZW9yZGVyGA0gASgLMhQub3dtLnYxLkxheWVyUmVvcmRlckgAEisKDHNjZW5lX3VwZGF0ZRgOIAEoCzITLm93bS52MS5TY2VuZVVwZGF0ZUgAEikKC3NjZW5lX2FwcGx5GA8gASgLMhIub3dtLnYxLlNjZW5lQXBwbHlIAEIGCgRraW5kIkoKB09wQmF0Y2gSFAoMYmFzZV92ZXJzaW9uGAEgASgEEhAKCHNjZW5lX2lkGAIgASgJEhcKA29wcxgDIAMoCzIKLm93bS52MS5PcEIbWhlvd20vcHJvdG9jb2wvb3dtL3YxO293bXYxYgZwcm90bzM", [file_google_protobuf_struct, file_owm_v1_scene]);
/**
 * Describes the message owm.v1.LayerAdd.
 * Use `create(LayerAddSchema)` to create a new message.
 */
export const LayerAddSchema = /*@__PURE__*/ messageDesc(file_owm_v1_ops, 0);
/**
 * Describes the message owm.v1.LayerRemove.
 * Use `create(LayerRemoveSchema)` to create a new message.
 */
export const LayerRemoveSchema = /*@__PURE__*/ messageDesc(file_owm_v1_ops, 1);
/**
 * Describes the message owm.v1.LayerPatch.
 * Use `create(LayerPatchSchema)` to create a new message.
 */
export const LayerPatchSchema = /*@__PURE__*/ messageDesc(file_owm_v1_ops, 2);
/**
 * Describes the message owm.v1.LayerUpdate.
 * Use `create(LayerUpdateSchema)` to create a new message.
 */
export const LayerUpdateSchema = /*@__PURE__*/ messageDesc(file_owm_v1_ops, 3);
/**
 * Describes the message owm.v1.LayerReorder.
 * Use `create(LayerReorderSchema)` to create a new message.
 */
export const LayerReorderSchema = /*@__PURE__*/ messageDesc(file_owm_v1_ops, 4);
/**
 * Describes the message owm.v1.ScenePatch.
 * Use `create(ScenePatchSchema)` to create a new message.
 */
export const ScenePatchSchema = /*@__PURE__*/ messageDesc(file_owm_v1_ops, 5);
/**
 * Describes the message owm.v1.SceneUpdate.
 * Use `create(SceneUpdateSchema)` to create a new message.
 */
export const SceneUpdateSchema = /*@__PURE__*/ messageDesc(file_owm_v1_ops, 6);
/**
 * Describes the message owm.v1.SceneApply.
 * Use `create(SceneApplySchema)` to create a new message.
 */
export const SceneApplySchema = /*@__PURE__*/ messageDesc(file_owm_v1_ops, 7);
/**
 * Describes the message owm.v1.Op.
 * Use `create(OpSchema)` to create a new message.
 */
export const OpSchema = /*@__PURE__*/ messageDesc(file_owm_v1_ops, 8);
/**
 * Describes the message owm.v1.OpBatch.
 * Use `create(OpBatchSchema)` to create a new message.
 */
export const OpBatchSchema = /*@__PURE__*/ messageDesc(file_owm_v1_ops, 9);
//# sourceMappingURL=ops_pb.js.map